import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import { UseFilterValuesType } from '@/components/FilterNew/types';
import { usePaginatedgetLabelCategoriesQuery } from '@/modules/tasks/graphql/queries/generated/paginatedgetLabelCategories';
import { SORT_BY } from '@/modules/tasks/views/TaskStasusesManager/hooks/useStatuses';

import useFilterValue from '../../hooks/useFilterValue';
import useTaskStatusOptionsQuery from './useLabelCategoryOptionsQuery';
import { getLabelCategoryOption } from './utils';

const useLabelCategoryValues: UseFilterValuesType = ({ value }) =>
  useFilterValue({
    value,
    useQuery: usePaginatedgetLabelCategoriesQuery,
    edgeKey: 'labelCategories',
    variables: {
      filters: {},
      sort: SORT_BY,
    },
    getFilterOption: getLabelCategoryOption,
  });

export const LabelCategoryEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useOptionsQuery: useTaskStatusOptionsQuery,
  useFilterValues: useLabelCategoryValues,
};
